import { useTranslation } from "react-i18next";
import { Card, CardBody, CardHeader } from "reactstrap";

function ConnectionCard({ onDisconnect }) {
	const { t } = useTranslation();
	return (
		<Card data-testid="hibob-connection-card">
			<CardHeader>
				<h2 className="hibob-card-title">{t("hibob-connection")}</h2>
			</CardHeader>
			<CardBody>
				<p className="mb-2">{t("hibob-connection-text")}</p>
				<button type="button" className="hibob-link-button is-danger" onClick={onDisconnect}>
					{t("hibob-disconnect-link")}
				</button>
				<p className="hibob-muted text-sm mb-0 mt-3">{t("hibob-uninstall-note-full")}</p>
			</CardBody>
		</Card>
	);
}

export default ConnectionCard;
